import { baseServiceConfig, freeBaseServiceConfig } from './shared-forms/base-service/base-service-config';
import { servicesConfig } from './services/services-config';
import { dlConfig } from './dl/dl-config';
import serviceRequestConfig from './service-request/service-request-config';
import profileConfig from './profile/profile-config';
import { pricingConfig } from './pricing/pricing-config';
import licenseConfig from './license/license-config';
import paymentConfig from './payment/payment-config';
import i18next from 'i18next';
import en from './i18n/en';
import serviceRunConfig from './service-run/service-run-config';

i18next.addResourceBundle('en', 'aiaas', en);

const aiaasConfigs = [
    baseServiceConfig,
    servicesConfig,
    dlConfig,
    profileConfig,
    serviceRunConfig,
    serviceRequestConfig,
    pricingConfig,
    licenseConfig,
    paymentConfig
];

export default aiaasConfigs;